import React, { useState, useContext } from 'react'
import classnames from 'classnames'
import styles from './index.module.less'

import Rewards from './rewards'
import Referral from './referral'
import context from '../../context'

interface IProps {
  inviteUsers: number
  inviteSettledUsers: number
}

const Record = (props: IProps) => {
  const [tab, setTab] = useState<number>(1)
  const { rewardDetail, referralHistory } = useContext(context)
  const rewardsTab = tab === 1
  return (
    <div className={styles.record}>
      <div className={styles.tabs}>
        <span className={classnames({ [styles.checked]: rewardsTab })} onClick={() => setTab(1)}>
          {rewardDetail.tabName}
        </span>
        <span className={classnames({ [styles.checked]: tab === 2 })} onClick={() => setTab(2)}>
          {referralHistory.tabName}
        </span>
      </div>
      {rewardsTab ? <Rewards /> : <Referral {...props} />}
    </div>
  )
}

export default Record
